import { SearchPage } from '../pages/search-page';
import { routeUrl } from '../constants/route-url';

export const searchRoute = {
  path: routeUrl,
  element: <SearchPage />
};
